import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Grid, GridColumn, Icon, Separator, Tooltip, TooltipToggle } from 'telia-front-react';
import { useInternetOffers } from '../InternetOffersProvider';
import { formatPlanDueDate, FWA_TECHNOLOGIES, is5gTechnology, isPlanDueDateInPast, resolveOfferIcon, resolveOfferOwnerLabel } from '../util/InternetOfferUtil';
const InternetOfferCharacteristics = (props) => {
    const { offer, inForm } = props;
    const { translate } = React.useContext(TranslationsContext);
    const { calculatorState } = useInternetOffers();
    const is5G = is5gTechnology(offer.technology);
    const isPlanned = offer.properties.includes('PLANNED');
    const isPartner = offer.properties.includes('PARTNER');
    const isSecureNet = offer.properties.includes('SECURE_NET');
    const plannedTechnologyDescription = () => {
        if (offer.planDueDate) {
            const formattedDate = formatPlanDueDate(offer);
            const inPast = isPlanDueDateInPast(offer);
            return translate(`internetCalculator.plannedNetwork${is5G ? '5g' : ''}.${inPast ? 'descriptionWithPastDate' : 'descriptionWithDate'}`, {
                date: formattedDate
            });
        }
        return translate(`internetCalculator.plannedNetwork${is5G ? '5g' : ''}.description`);
    };
    const sharedTechnologyInformation = () => {
        return (React.createElement(Grid, { horizontalGutter: "small", align: ['middle-xs'], noWrap: true },
            React.createElement(GridColumn, { width: ['min'] },
                React.createElement(Icon, { modifiers: `${resolveOfferIcon(offer.technology)}`, size: "xs" })),
            React.createElement(GridColumn, { width: ['max'] }, offer.properties.includes('BASE_CONNECTION') ? (React.createElement("p", null, translate('internetCalculator.offerTitle.BASE_CONNECTION'))) : !FWA_TECHNOLOGIES.includes(offer.technology) && offer.properties.includes('SECURE_NET') ? (React.createElement("p", null, translate('secureNetCalculator.offerTitle.cableInternet'))) : (React.createElement("p", null, translate(`internetCalculator.offerTitle.${offer.technology}`))))));
    };
    const securityFilterAndDdosProtectionInfo = () => {
        return (!FWA_TECHNOLOGIES.includes(offer.technology) && (React.createElement(React.Fragment, null,
            React.createElement(Grid, { horizontalGutter: "small", align: ['middle-xs'], noWrap: true },
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Icon, { modifiers: '#security', size: "xs" })),
                React.createElement(GridColumn, { width: ['max'] },
                    React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, null,
                            React.createElement("strong", null, translate('secureNetCalculator.offerTitle.securityFilter'))), placement: "right" }, translate('secureNetCalculator.offerTitle.securityFilter.tooltipContent')))),
            React.createElement(Grid, { horizontalGutter: "small", align: ['middle-xs'], noWrap: true },
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Icon, { modifiers: '#lock', size: "xs" })),
                React.createElement(GridColumn, { width: ['max'] },
                    React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, null,
                            React.createElement("strong", null, translate('secureNetCalculator.offerTitle.ddosProtection'))), placement: "left" }, translate('secureNetCalculator.offerTitle.ddosProtection.tooltipContent')))))));
    };
    const technologyInformation = isSecureNet ? (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            sharedTechnologyInformation(),
            securityFilterAndDdosProtectionInfo(),
            React.createElement(Separator, { color: "invisible", spacing: inForm ? 'xsmall' : 'xxsmall' })),
        React.createElement("p", null, isPlanned ? plannedTechnologyDescription() : translate(`internetCalculator.${offer.productOfferingCode}.description`)))) : (React.createElement(React.Fragment, null,
        ((calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.address) || offer.isEdit) && (React.createElement(React.Fragment, null,
            sharedTechnologyInformation(),
            React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }))),
        React.createElement("p", null, isPlanned ? plannedTechnologyDescription() : translate(`internetCalculator.${offer.productOfferingCode}.description`))));
    if (isPartner) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { color: "invisible", spacing: inForm ? 'xsmall' : 'xxsmall' }),
            React.createElement(Grid, { verticalGutter: "none" },
                React.createElement(GridColumn, null,
                    React.createElement(Grid, { horizontalGutter: "small", align: ['middle-xs'], noWrap: true },
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(Icon, { modifiers: "#service-internet", size: "xs" })),
                        React.createElement(GridColumn, { width: ['max'] },
                            React.createElement("p", null, translate(resolveOfferOwnerLabel(offer.owner)))))),
                React.createElement(GridColumn, null, technologyInformation))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
        technologyInformation));
};
export default InternetOfferCharacteristics;
